import {StyleSheet} from 'react-native';
import Metrics from '../../../../../Theme/Metrics';

export const leadingCoverSize = StyleSheet.create({
  large: {
    width: Metrics.horizontalScale(109),
    height: Metrics.verticalScale(109),
    fontSize: Metrics.verticalScale(96),
  },
  medium: {
    width: Metrics.horizontalScale(109),
    height: Metrics.verticalScale(109),
    fontSize: Metrics.verticalScale(64),
  },
  big: {
    width: Metrics.horizontalScale(168),
    height: Metrics.verticalScale(94.5),
    fontSize: Metrics.verticalScale(96),
  },
});

export const TopTenCardStyles = StyleSheet.create({
  card: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    gap: 4,
    position: 'relative',
  },
  cover: {
    borderRadius: Metrics.moderateScale(4),
  },
});
